var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "iconColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8386 5.64913C12.0583 5.42946 12.4144 5.42946 12.6341 5.64913L15.5872 8.60225C15.8069 8.82192 15.8069 9.17808 15.5872 9.39775L12.6341 12.3509C12.4144 12.5705 12.0583 12.5705 11.8386 12.3509C11.6189 12.1312 11.6189 11.775 11.8386 11.5554L14.394 9L11.8386 6.44462C11.6189 6.22495 11.6189 5.8688 11.8386 5.64913Z",
    fill: "#25282B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "iconColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 9C6.75 8.68934 7.00184 8.4375 7.3125 8.4375H15.1875C15.4982 8.4375 15.75 8.68934 15.75 9C15.75 9.31066 15.4982 9.5625 15.1875 9.5625H7.3125C7.00184 9.5625 6.75 9.31066 6.75 9Z",
    fill: "#25282B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "iconColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5795 2.5795C2.79048 2.36853 3.07663 2.25 3.375 2.25H8.4375C8.74816 2.25 9 2.50184 9 2.8125C9 3.12316 8.74816 3.375 8.4375 3.375L3.375 3.375L3.375 14.625H8.4375C8.74816 14.625 9 14.8768 9 15.1875C9 15.4982 8.74816 15.75 8.4375 15.75H3.375C3.07663 15.75 2.79048 15.6315 2.5795 15.4205C2.36853 15.2095 2.25 14.9234 2.25 14.625V3.375C2.25 3.07663 2.36853 2.79048 2.5795 2.5795Z",
    fill: "#25282B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/SignOut.1690d036.svg";
export { ForwardRef as ReactComponent };